import { useTranslation } from 'react-i18next';

// Marka: sınav.uz'un logo mark'ı (8 köşeli Türk dünyası yıldızı, disk üzerinde) —
// "Butik Sıcaklık" paletine yeniden renklendirildi: disk terracotta (var(--color-primary),
// tema-duyarlı), yıldız sabit altın. Inline SVG, raster dosya yok.
const STAR_PATH =
    'M16,6 L18.68,9.53 L23.07,8.93 L22.47,13.32 L26,16 L22.47,18.68 ' +
    'L23.07,23.07 L18.68,22.47 L16,26 L13.32,22.47 L8.93,23.07 L9.53,18.68 ' +
    'L6,16 L9.53,13.32 L8.93,8.93 L13.32,9.53 Z';

const Mark = ({ size = 32 }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" className="shrink-0" role="img" aria-label="Türk Dünyası" aria-hidden="true">
        <circle cx="16" cy="16" r="16" fill="var(--color-primary)" />
        <circle cx="16" cy="16" r="15.3" fill="none" stroke="rgba(255,255,255,0.16)" strokeWidth="0.7" />
        <path d={STAR_PATH} fill="var(--color-accent)" />
    </svg>
);

const Logo = ({ size = 32, showWordmark = true, className = '' }) => {
    const { t } = useTranslation();

    return (
        <span className={`inline-flex items-center gap-2.5 ${className}`}>
            <Mark size={size} />
            {showWordmark && (
                <span className="font-heading leading-none tracking-tight whitespace-nowrap" style={{ fontSize: size * 0.72 }}>
                    {t('common.brand')}
                </span>
            )}
        </span>
    );
};

export default Logo;
